export default function MobileFilterSheet({ open, onClose, title = "Filtros", children }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col justify-end" role="presentation">
      <button
        type="button"
        aria-label="Fechar filtros"
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-label={title}
        className="relative max-h-[80vh] overflow-y-auto rounded-t-2xl border-t border-primary bg-mgs-bg px-4 pb-6 pt-4 shadow-xl"
      >
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-laranjinha">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-laranjinha hover:bg-monao"
          >
            Fechar
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
